<template>
  <el-result
    class="submit-success"
    icon="success"
    title="提交成功"
    subTitle="我们已经收到您的申请，审核通过后我们将通过电话联系您"
  >
    <template slot="extra">
      <el-button size="default" type="primary" @click="$router.go(-1)"
        >返回</el-button
      >
    </template>
  </el-result>
</template>
<script>
export default {
  name: 'submit-success',
  mounted() {
    this.setIframeHeight()
    this.setParentScrollTop(0)
  },
  methods: {
    setIframeHeight() {
      window.parent.postMessage(
        {
          callback: 'setIframeHeight',
          args: [500],
        },
        '*'
      )
    },
    setParentScrollTop(scrollTop) {
      this.isSetParentScrollTop = true
      window.parent.postMessage(
        {
          callback: 'setScrollTop',
          args: [scrollTop],
        },
        '*'
      )
    },
  },
}
</script>
<style lang="less">
.submit-success {
  height: 75%;
  .el-button--primary {
    background-color: #028be6;
    border-color: #028be6;
  }
}
</style>